import { SKIN_SOLUTION } from "../constants/url";
import { catchErrors } from "../utils/catchErrors";
import { getApiCall } from "../utils/servicesBaseUtil";

export const getSkinSolutionApi = ({
  finalCallback,
  successCallback,
  unAunthenticatedCallback,
}) => {
  return () => {
    let url = SKIN_SOLUTION;

    getApiCall({ url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        } else {
          if (unAunthenticatedCallback) {
            unAunthenticatedCallback();
          }
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        if (finalCallback) {
          finalCallback();
        }
      });
  };
};
